import { PostFunction } from "src/utils/axios_connection";
import { quietPost } from "src/pages/catalogue/api";

// Checkout options (API docs/faster-decision.md, docs/refusal-protection.md,
// migration 034). Reads fail quietly (the screen says so, with Retry);
// changes show the server's message when they fail.
const change = (route, data, dispatch) => PostFunction({ Route: route, data, isMultipart: false, showalert: false, showerror: true, dispatch });

export const checkoutApi = {
  // { migrated, scope, id, name, own, inherited, effective, quotes, rates, limits }, or false.
  options: (scope, id, dispatch) => quietPost({ route: "checkout/options/get", data: { scope, id: Number(id) }, dispatch }),
  saveOptions: (scope, id, body, dispatch) => change("checkout/options/update", { scope, id: Number(id), ...body }, dispatch),
  rates: (dispatch) => quietPost({ route: "checkout/rates/get", data: {}, dispatch }),
  saveRate: (rate, dispatch) => change("checkout/rates/update", rate, dispatch),
  speedNotOffered: (applicationId, dispatch) => change("checkout/speed/not-offered", { application_id: Number(applicationId) }, dispatch),
  speedRefunded: (applicationId, dispatch) => change("checkout/speed/refunded", { application_id: Number(applicationId) }, dispatch),
  protectionRefunded: (addonId, dispatch) => change("checkout/protection/refunded", { addon_id: Number(addonId) }, dispatch),
  protectionNotCovered: (addonId, reason, dispatch) => change("checkout/protection/not-covered", { addon_id: Number(addonId), reason }, dispatch),
};
